import React from 'react';
import PropTypes from 'prop-types';
import FilterPill from '../filterpill/FilterPill';

const renderValue = (value) => {
    if (value.from !== null && value.to !== null) return `${(value.from)} - ${(value.to)}`;

    if (value.from !== null) return `>= ${(value.from)}`;

    if (value.to !== null) return `<= ${(value.to)}`;

    return 'All';
};

const NumberFilterPill = (props) => (
    <FilterPill
        fixed={ props.fixed }
        disabled={ props.disabled }
        filter={ props.filter }
        filterError={ props.filterError }
        displayValue={ renderValue(props.filter.value) }
        isOpen={ props.isOpen }
        openFilter={ props.openFilter }
        removeFilter={ props.removeFilter }
        updateFilter={ props.updateFilter }
    />
);

NumberFilterPill.propTypes = {
    fixed: PropTypes.bool,
    disabled: PropTypes.bool,
    filter: PropTypes.shape({
        title: PropTypes.string.isRequired,
        value: PropTypes.shape({
            from: PropTypes.number,
            to: PropTypes.number,
        })
    }),
    filterError: PropTypes.shape({}),
    isOpen: PropTypes.bool,
    openFilter: PropTypes.func.isRequired,
    removeFilter: PropTypes.func.isRequired,
    updateFilter: PropTypes.func.isRequired
};

NumberFilterPill.defaultProps = {
    fixed: false,
    isOpen: false,
    filterError: null,
    disabled: false,
    filter: {
        value: null
    }
};

export default NumberFilterPill;
